import { render } from "./App_Shell.vue?vue&type=template&id=98051ba4"
import script from "./App_Shell.vue?vue&type=script&lang=js"
export * from "./App_Shell.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__